import React from 'react';
import SearchFiltersRangeSqFt from './SearchFiltersRangeSqFt';
import SearchFiltersBedrooms from './SearchFiltersBedrooms';
import SearchFiltersBathrooms from './SearchFiltersBathrooms';
import SearchFiltersGarages from './SearchFiltersGarages';
import SearchFiltersRefinementList from './generic/SearchFiltersRefinementList';
import SearchFiltersToggle from './generic/SearchFiltersToggle';
import { useSearchStateIndex } from '../hooks/useSearchStateIndex';
import config from '../config/config';

const SearchFiltersHomeDetails = () => {
	const { activeIndexName } = useSearchStateIndex();

	return (
		<div className='tw-space-y-6'>
			<div>
				<SearchFiltersRangeSqFt />
			</div>
			<div>
				<SearchFiltersBedrooms />
			</div>
			<div>
				<SearchFiltersBathrooms />
			</div>
			<div>
				<SearchFiltersGarages />
			</div>

			{activeIndexName.includes( 'homes' ) && (
				<>
					<SearchFiltersRefinementList
						attribute={config.FILTER_ATTRIBUTES.homeType}
						label="Home Type"
					/>

					<SearchFiltersToggle
						attribute={config.FILTER_ATTRIBUTES.modelTour}
						label="Model Home Available to Tour"
						headerText="Model"
					/>
					<SearchFiltersRefinementList
						attribute={config.FILTER_ATTRIBUTES.homeFeature}
						label="Home Features"
					/>
				</>
			)}
		</div>
	);
};

export default SearchFiltersHomeDetails;
